import type { FC } from 'react';

interface FlagProps {
  countryCode: string;
}
export const Flag: FC<FlagProps> = ({ countryCode }) => {
  return <span className={`fib fi-${countryCode} block h-3 w-4`} />;
};
